import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './index';
import authErrorMiddleware from './authErrorMiddleware';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(authErrorMiddleware),
});
